import {Card} from './Card'
const data = require('../../config/cards.json')['Ranch']

export default class Ranch extends Card {
	constructor() {
		super(data)
	}

	/**
	 * Give one coin to player
	 */
	activate() {
		this.owner.coins++
	}
}
